import { FC, ReactNode } from 'react';
import styles from './PunchupAnalyticsEmptyState.module.css';

interface Props {
	children: ReactNode;
}

export const PunchupAnalyticsEmptyState: FC<Props> = ({ children }) => <p className={styles.root}>{children}</p>;
